<template>
  <div class="col responsive-width">
    <div class="container-fluid">
      <div class="content">
        <div class="d-flex align-items-center flex-wrap justify-content-between">
          <div>
            <h1 class="mb-0">{{ $t('alerts') }}</h1><span>{{ $t('inbox') }} ({{ ALERT.length }})</span>
          </div>
          <router-link :to="{ name : 'alertarchived' }" class="my-3 my-sm-0"> {{
              $t('see_archived_alert')
            }}
          </router-link>
        </div>
        <div class="box">
          <div class="box-responsive">
            <table>
              <thead>
              <tr>
                <th>{{ $services.helpers.capitalizeNames($t('subject')) }}</th>
                <th style="width:60%">{{ $services.helpers.capitalizeNames($t('alert')) }}</th>
                <th>{{ $services.helpers.capitalizeNames($t('received')) }}</th>
                <th style="width:10%"></th>
              </tr>
              </thead>

              <tbody v-if="ALERT.length > 0">
              <tr v-for="alert in ALERT" :key="alert.id">
                <td><span v-if="alert.alert_code">{{ alert.alert_code.code }}</span></td>
                <td>
                  <p v-if="LOCALE === 'en'">{{ alert.eng_message }}</p>
                  <p v-else>{{ alert.swe_message }}</p>
                </td>
                <td>{{ alert.received.split('T')[0] }}</td>
                <td>
                  <router-link :to="{ name : 'alertmessage', params : { id : alert.id } }">{{ $t('see_full_message') }}
                  </router-link>
                  <div class="icons">
                    <svg @click="openAlertMessage(alert)" width="20" height="20" viewbox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M0 1.42857C0 1.04969 0.131696 0.686328 0.366117 0.418419C0.600537 0.15051 0.918479 0 1.25 0H18.75C19.0815 0 19.3995 0.15051 19.6339 0.418419C19.8683 0.686328 20 1.04969 20 1.42857V4.28571C20 4.6646 19.8683 5.02796 19.6339 5.29587C19.3995 5.56378 19.0815 5.71429 18.75 5.71429V16.4286C18.75 17.3758 18.4208 18.2842 17.8347 18.954C17.2487 19.6237 16.4538 20 15.625 20H4.375C3.5462 20 2.75134 19.6237 2.16529 18.954C1.57924 18.2842 1.25 17.3758 1.25 16.4286V5.71429C0.918479 5.71429 0.600537 5.56378 0.366117 5.29587C0.131696 5.02796 0 4.6646 0 4.28571V1.42857ZM2.5 5.71429V16.4286C2.5 16.9969 2.69754 17.5419 3.04917 17.9438C3.40081 18.3457 3.87772 18.5714 4.375 18.5714H15.625C16.1223 18.5714 16.5992 18.3457 16.9508 17.9438C17.3025 17.5419 17.5 16.9969 17.5 16.4286V5.71429H2.5ZM18.75 1.42857H1.25V4.28571H18.75V1.42857ZM6.25 9.28571C6.25 9.09627 6.31585 8.91459 6.43306 8.78064C6.55027 8.64668 6.70924 8.57143 6.875 8.57143H13.125C13.2908 8.57143 13.4497 8.64668 13.5669 8.78064C13.6842 8.91459 13.75 9.09627 13.75 9.28571C13.75 9.47515 13.6842 9.65684 13.5669 9.79079C13.4497 9.92475 13.2908 10 13.125 10H6.875C6.70924 10 6.55027 9.92475 6.43306 9.79079C6.31585 9.65684 6.25 9.47515 6.25 9.28571Z"
                          fill="#0E1566"></path>
                    </svg>
                    <svg @click="openDeletedMessageModal(alert)" width="20" height="21" viewbox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M9.75012 6.97518e-09C10.6251 -5.43467e-05 11.467 0.317554 12.103 0.887672C12.7391 1.45779 13.121 2.23719 13.1706 3.066L13.1758 3.25H18.7097C18.91 3.25006 19.1028 3.32224 19.2492 3.45197C19.3955 3.5817 19.4845 3.7593 19.4982 3.94888C19.5118 4.13846 19.4491 4.32589 19.3227 4.4733C19.1963 4.62071 19.0156 4.7171 18.8172 4.743L18.7097 4.75H17.8707L16.5214 17.77C16.4538 18.4191 16.1453 19.0243 15.6508 19.4775C15.1563 19.9306 14.5081 20.2023 13.822 20.244L13.6365 20.25H5.86378C5.17596 20.25 4.51056 20.0179 3.98649 19.5953C3.46242 19.1727 3.11384 18.587 3.00304 17.943L2.97879 17.769L1.62853 4.75H0.79055C0.599514 4.74999 0.414942 4.68436 0.270968 4.56523C0.126995 4.44611 0.0333594 4.28155 0.00737844 4.102L0 4C8.05613e-06 3.81876 0.0691917 3.64366 0.194757 3.50707C0.320322 3.37048 0.493774 3.28165 0.683035 3.257L0.79055 3.25H6.3244C6.3244 2.38805 6.68533 1.5614 7.32777 0.951903C7.97022 0.34241 8.84156 6.97518e-09 9.75012 6.97518e-09ZM16.2822 4.75H3.21701L4.55252 17.622C4.58209 17.9092 4.7155 18.1779 4.93011 18.3824C5.14472 18.5869 5.4273 18.7147 5.72991 18.744L5.86378 18.75H13.6365C14.2689 18.75 14.8054 18.325 14.9277 17.748L14.9488 17.622L16.2811 4.75H16.2822ZM11.5947 7.5C11.7858 7.50001 11.9703 7.56564 12.1143 7.68477C12.2583 7.80389 12.3519 7.96845 12.3779 8.148L12.3853 8.25V15.25C12.3852 15.44 12.3091 15.6229 12.1724 15.7618C12.0357 15.9006 11.8485 15.9851 11.6486 15.998C11.4488 16.011 11.2512 15.9515 11.0958 15.8316C10.9405 15.7117 10.8389 15.5402 10.8116 15.352L10.8042 15.25V8.25C10.8042 8.05109 10.8875 7.86032 11.0357 7.71967C11.184 7.57902 11.3851 7.5 11.5947 7.5ZM7.9055 7.5C8.09654 7.50001 8.28111 7.56564 8.42509 7.68477C8.56906 7.80389 8.66269 7.96845 8.68868 8.148L8.69605 8.25V15.25C8.69599 15.44 8.6199 15.6229 8.48316 15.7618C8.34642 15.9006 8.15922 15.9851 7.95939 15.998C7.75956 16.011 7.56199 15.9515 7.40661 15.8316C7.25124 15.7117 7.14963 15.5402 7.12233 15.352L7.11495 15.25V8.25C7.11495 8.05109 7.19824 7.86032 7.3465 7.71967C7.49476 7.57902 7.69584 7.5 7.9055 7.5ZM9.75012 1.5C9.28719 1.50002 8.84118 1.66517 8.50064 1.96268C8.1601 2.26019 7.94992 2.6683 7.91183 3.106L7.9055 3.25H11.5947C11.5947 2.78587 11.4004 2.34075 11.0545 2.01256C10.7085 1.68437 10.2393 1.5 9.75012 1.5Z"
                          fill="#FB4B4B"></path>
                    </svg>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="4">
                  <empty-component :title="$t('empty_alert')"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalAlertVue v-if="showArchiveAlert" @handleClose="showArchiveAlert = false" :close="!true">
    <h4>{{ $t('unarchived_message') }}<span class="user-confirm text-danger">{{ $t('alert_message') }}</span>?</h4>
    <div class="popup-bottons">
      <button @click="showArchiveAlert = false">{{ $t('cancel_delete_request') }}</button>
      <button :disabled='processing' @click="archiveAlertMessage">
        <span v-if="processing">{{ $t('archiving') }}...</span>
        <span v-else>{{ $t('accept_delete_request') }}</span>
      </button>
    </div>
  </ModalAlertVue>
  <ModalAlertVue v-if="showDeletedModalAlert" @handleClose="showDeletedModalAlert = false" :close="!true">
    <h4>{{ $t('delete_confirmation_text') }} <span class="user-confirm text-danger">{{ $t('alert_message') }}</span>?
    </h4>
    <div class="popup-bottons">
      <button @click="showDeletedModalAlert = false">{{ $t('cancel_delete_request') }}</button>
      <button :disabled='processing' @click="deleteAlertMessage">
        <span v-if="processing">{{ $t('deleting') }}...</span>
        <span v-else>{{ $t('accept_delete_request') }}</span>
      </button>
    </div>
  </ModalAlertVue>
</template>

<script>
import {mapGetters} from 'vuex'
import ModalAlertVue from '../../components/ModalAlert.vue'
import EmptyComponent from "./reusableComponents/EmptyComponent";

export default {
  components: {ModalAlertVue, EmptyComponent},
  data() {
    return {
      showArchiveAlert: false,
      showDeletedModalAlert: false,
      processing: false,
      selectedAlert: null
    }
  },
  computed: {
    ...mapGetters({
      ALERT: 'clients/GET_NOTIFY_ALERT',
      LOCALE: 'locale/GET_LOCALE'
    })
  },
  mounted() {
    this.getNotifyAlert()
  },
  methods: {
    getNotifyAlert() {
      this.$store.dispatch('clients/getNotificationAlert', null)
    },
    archiveAlertMessage() {
      this.processing = true
      const payload = {
        archived: true,
        id: this.selectedAlert.id
      }
      this.$store.dispatch('clients/archiveAlertMessage', payload)
          .then(res => {
            this.processing = false
            this.getNotifyAlert()
            this.showArchiveAlert = false
            // this.$services.helpers.notification('Successful archived alert message', 'success', this)
            this.$toast.success(this.$t('archived_alert'));
          })
          .catch(err => {
            this.processing = false
            this.$services.helpers.notification(err.response.data.message, 'error', this)
          })
    },
    deleteAlertMessage() {
      this.processing = true
      const payload = {
        id: this.selectedAlert.id
      }
      this.$store.dispatch('clients/deleteAlertMessage', payload)
          .then(res => {
            this.processing = false
            this.getNotifyAlert()
            this.showDeletedModalAlert = false
            // this.$services.helpers.notification('Alert message deleted successfully', 'success', this)
            this.$toast.success(this.$t('deleted_alert'));
          })
          .catch(err => {
            this.processing = false
            this.$services.helpers.notification(err.response.data.message, 'error', this)
          })
    },
    openDeletedMessageModal(data) {
      this.selectedAlert = data
      this.showDeletedModalAlert = true
    },
    openAlertMessage(data) {
      this.selectedAlert = data
      this.showArchiveAlert = true
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content h1 {
  margin: 20px 0;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content h1 ~ span {
  font-size: 18px;
  line-height: 28px;
  color: #27364b;
}

.content div ~ a {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #5855d6;
  text-decoration: none;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 10px 18px;
  border: 1px solid #5855d6;
  height: 44px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content div ~ a:hover {
  color: #4946ae;
  border-color: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 5px;
  padding: 20px 40px 40px;
  margin-top: 20px;
}

.content table {
  width: -webkit-calc(100% - 30px);
  width: calc(100% - 30px);
  min-width: 970px;
}

.content table tr {
  border-bottom: 1px solid rgba(151, 151, 151, 0.72);
  position: relative;
}

.content table thead th {
  padding: 0 10px 10px;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #333269;
}

.content table tbody tr {
  height: 95px;
}

.content table tbody td:first-of-type {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.content table tbody td p {
  font-size: 12px;
  line-height: 18px;
  margin: 0;
  color: #000000;
}

.content table tbody td:nth-child(3) {
  font-size: 12px;
  line-height: 18px;
  color: #000000;
}

.content table tbody td a {
  text-decoration: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #5855d6;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content table tbody td a:hover {
  color: #4946ae;
}

.content table tbody td .icons {
  position: absolute;
  right: -30px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.content table tbody td .icons svg {
  cursor: pointer;
}

.content table tbody td .icons svg:first-of-type {
  margin-bottom: 10px;
}
</style>